var _circle, _circle2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIfheLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#1a4d9e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 115,
    fontSize: 48,
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "IFHE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfheLogo);
export default __webpack_public_path__ + "static/media/ifheLogo.0cc8d667be515e6d67deda8275a9e8b8.svg";
export { ForwardRef as ReactComponent };